import * as yup from 'yup';

export const useOffencesStepFormSchema = () => {
  const schema = yup.object({
    convictedOffence: yup.string().required(),
    offencesList: yup.array().when(['convictedOffence'], {
      is: (convictedOffence: string) => convictedOffence === '1',
      then: (schema) => schema.of(
        yup.object().shape({
          offenceDate: yup.string().required('Date is a required field'),
          offenceName: yup.string(),
        }),
      ),
      otherwise: (schema) => schema.nullable(),
    }),
  });

  return { schema };
};
